import React, { useState, useEffect } from 'react';
import './scss/marquee.scss';
import api from './services/apiService';
import { FaTrophy } from 'react-icons/fa';

function Marquee() {
  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const teamId = sessionStorage.getItem('selected_team_id');
        const responses = await api.get(`${process.env.REACT_APP_API_URL}/get_announcements.php?team_id=${teamId}&source=marquee`);

        const response = responses.data;

        if (response.success) {
          console.log('Formatted announcements:', response.announcements);
          setAnnouncements(response.announcements);
        } else {
          console.error('Failed to fetch announcements');
        }
      } catch (error) {
        console.error('Error fetching announcements:', error);
      }
    };

    fetchAnnouncements();
  }, []);

  useEffect(() => {
    // Add or remove class based on announcements
    if (announcements.length === 0) {
      document.body.classList.add('no-announcements');
    } else {
      document.body.classList.remove('no-announcements');
    }

    // Cleanup function to remove class when component unmounts
    return () => {
      document.body.classList.remove('no-announcements');
    };
  }, [announcements]);

  if (announcements.length === 0) {
    return null; // Return null to hide the component if there are no announcements
  }

  return (
    <div className="marquee">
      <div className="marquee-content">
        {announcements.map((announcement, index) => (
          <span key={index} className={`marquee-item ${announcement.type}`}>
            {announcement.message}
          </span>
        ))}
      </div>
    </div>
  );
}

export default Marquee; 